import React, { useRef, useEffect, useMemo } from 'react';
import DataGrid, { Column } from 'devextreme-react/data-grid';
import { Item as TabItem } from "devextreme-react/tab-panel";
import Form, { GroupItem, SimpleItem, FormRef } from "devextreme-react/form";
import ITrancheAge from '../../models/ITrancheAge';
import { FormListBase, FormListBaseTab, FormListBaseGrid, FormListBaseToolbar } from '../base';
import useCustomDataSource, { IFormBaseDataSourceOptions, Mode } from "../../hooks/useCustomDataSource";
import FormSysteme from '../../components/forms/form-systeme';
import "./configuration.css";
import { useContextPopupPage } from '../../components/popups/PopupPage';

interface IConfigurationTranchesAgesProps {
  isModeSelection?: boolean,
}

export default function ConfigurationTranchesAges({ isModeSelection }: IConfigurationTranchesAgesProps) {
  const trancheAgeFormDataSource = useCustomDataSource<ITrancheAge, ITrancheAge>({ path: "trancheAge", primaryKey: "idTrancheAge" });
  const { setMainForm, selectedDataRow: selectedTrancheAge, mode, setMode, isFieldModifier, onFieldDataChanged } = trancheAgeFormDataSource;
  const formRef = useRef<FormRef>(null);
  const { setSelectedValue } = useContextPopupPage();

  const ageEditorOptions = useMemo(() => {
    return { min: 0, max: 120, showSpinButtons: true, width: '65px' }
  }, []);

  const isAdulteCheckBoxOptions = useMemo(() => ({ text: 'Tranche adulte' }), []);
  const ignorerPourAutantEnfantsQueAdultesCheckBoxOptions = useMemo(() => ({
    text: `Ignorer cette tranche quand l'option "Permettre autant d'enfants que d'adultes avant de facturer des enfants additionnels" est cochée dans un détail de plan`,
  }), []);
  const actifCheckBoxOptions = useMemo(() => ({ text: 'Actif' }), []);

  useEffect(() => {
    setMainForm(formRef.current?.instance());
  })

  console.log(selectedTrancheAge);
  return (
    <FormListBase data={trancheAgeFormDataSource}>
      <FormListBaseGrid dataSource={trancheAgeFormDataSource.dataSource}
        onFocusedRowChanged={(e: any) => {
          if (mode === Mode.Modifier) {
            setMode(Mode.Lecture);
          }
          if (setSelectedValue && e.row?.data) {
            setSelectedValue(e.row.data);
          }
        }}>
        <Column key={"grid-col-ageDebut"} dataField={"ageDebut"} caption="Âge début" allowHiding={false} />
        <Column key={"grid-col-ageFin"} dataField={"ageFin"} caption="Âge fin" allowHiding={false} />
        <Column key={"grid-col-isAdulte"} dataField={"isAdulte"} caption="Tranche adulte" allowHiding={false} />
      </FormListBaseGrid>
      <FormListBaseToolbar removeBlocked={true} headerText={`Tranche d'âge de ${selectedTrancheAge?.ageDebut || 0} à ${selectedTrancheAge?.ageFin || ''}`} sauvegarderOptions={{ disabled: !isFieldModifier }} annulerOptions={{ disabled: !isFieldModifier }} effacerOptions={{ visible: false, disabled: !isFieldModifier }} />
      {!isModeSelection || isModeSelection && mode !== Mode.Lecture
        ? <FormListBaseTab>
          <TabItem title="Informations">
            <Form ref={formRef} readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={false} formData={selectedTrancheAge || {} as ITrancheAge} className={"forms configuration-tranches-ages-form"} labelLocation={"left"} showColonAfterLabel={true} onFieldDataChanged={onFieldDataChanged}>
              <GroupItem alignItemLabels={true}>
                <SimpleItem key={"frm-agedebut"} dataField={"ageDebut"} editorType={"dxNumberBox"} editorOptions={ageEditorOptions} />
                <SimpleItem key={"frm-agefin"} dataField={"ageFin"} editorType={"dxNumberBox"} editorOptions={ageEditorOptions} />
              </GroupItem>
              <GroupItem alignItemLabels={false}>
                <SimpleItem key={"frm-isAdulte"} dataField={"isAdulte"} editorType={"dxCheckBox"} editorOptions={isAdulteCheckBoxOptions} label={{ visible: false }} />
                <SimpleItem key={"frm-ignorerPourAutantEnfantsQueAdultes"} dataField={"ignorerPourAutantEnfantsQueAdultes"} editorType={"dxCheckBox"} editorOptions={ignorerPourAutantEnfantsQueAdultesCheckBoxOptions} label={{ visible: false }} />
                <SimpleItem key={"frm-actif"} dataField={"actif"} editorType={"dxCheckBox"} editorOptions={actifCheckBoxOptions} label={{ visible: false }} />
              </GroupItem>
            </Form>
          </TabItem>
          <TabItem title="Système"><FormSysteme formData={selectedTrancheAge || {} as ITrancheAge} /></TabItem>
        </FormListBaseTab> : null}
    </FormListBase>
  );
}